import {appAPI} from "../../../api";
import {INewTracker, INewTrackerPayment, ITracker} from "../../../models/ITracker";

const trackerPath = `/tracker/db`;

/**
 * PATCH-пейлоад — явный whitelist: наружу уходят только редактируемые поля.
 * Спред всего ITracker слал бы на бэк relations (machinery, backup_machinery,
 * sim_payment) — бэк их режет, но контракт держим чистым.
 */
interface UpdateTrackerPayload {
    id: string;
    imei: string;
    model: ITracker["model"];
    protocol: ITracker["protocol"];
    phone: string;
    password: string;
    status: ITracker["status"];
    monthly_tariff: string;
    /** Роль устройства (основной/маяк) — редактируется в таблице трекеров. */
    kind: ITracker["kind"];
}

const toUpdatePayload = (t: ITracker): UpdateTrackerPayload => ({
    id: t.id,
    imei: t.imei,
    model: t.model,
    protocol: t.protocol,
    phone: t.phone,
    password: t.password,
    status: t.status,
    monthly_tariff: t.monthly_tariff,
    kind: t.kind,
});

export const trackersAPI = {
    add: async (tracker: INewTracker) => {
        const res = await appAPI.post(trackerPath, tracker);
        return res.data;
    },
    getAll: async () => {
        const res = await appAPI.get(trackerPath);
        return res.data;
    },
    getById: async (id: string) => {
        const res = await appAPI.get(`${trackerPath}/id/${id}`);
        return res.data;
    },
    update: async (tracker: ITracker) => {
        const res = await appAPI.patch(`${trackerPath}/${tracker.id}`, toUpdatePayload(tracker));
        return res.data;
    },
    delete: async (id: string) => {
        const res = await appAPI.delete(`${trackerPath}/${id}`);
        return res.data;
    },
    // ─── Оплаты SIM ───
    addPayment: async (trackerId: string, payment: INewTrackerPayment) => {
        const res = await appAPI.post(`${trackerPath}/${trackerId}/payments`, payment);
        return res.data;
    },
    deletePayment: async (trackerId: string, paymentId: string) => {
        const res = await appAPI.delete(`${trackerPath}/${trackerId}/payments/${paymentId}`);
        return res.data;
    },
};